import { DynamicObjectInterface } from '../type';
import { AxiosUtilsType, axiosGet, axiosPost, axiosPut, axiosPatch } from './axiosUtils';
import './axiosInterceptor';

const CoachService = {
  async getCoachList(): AxiosUtilsType {
    return await axiosGet(`coach/list`);
  },

  async createCoach(coach: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`coach/create`, coach);
  },

  async getCoachDetails(selectedRowId: string): AxiosUtilsType {
    return await axiosGet(`coach/list/${selectedRowId}`);
  },

  async getCoachByAboId(aboId: string): AxiosUtilsType {
    return await axiosGet(`coach/getCoachByAboId/${aboId}`);
  },

  async updateCoach(selectedRowId: string, coach: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPut(`coach/list/${selectedRowId}`, coach);
  },

  async deleteCoach(selectedRowId: string): AxiosUtilsType {
    return await axiosPatch(`coach/list/${selectedRowId}`);
  },

  async getCoachExportCSV(): AxiosUtilsType {
    return await axiosGet(`coach/export/csv`);
  },

  async getCoachByCampaignId(campaignId: string, leaderAboId?: string): AxiosUtilsType {
    return await axiosGet(`/coach/campaign?id=${campaignId}${leaderAboId ? '&leaderAboId=' + leaderAboId : ''}`);
  },

  async getCoachDetailByCampaignId(recId: string): AxiosUtilsType {
    return await axiosGet(`/coach/campaign/${recId}`);
  },

  async updateTeamCoachDetails(selectedRowId: string, coach: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPut(`/coach/campaign/${selectedRowId}?section=${coach?.section}`, coach);
  },
};
export default CoachService;
